function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import { Block } from '../block';
import { getLinkRel } from '../../helpers';
var buttonResetStyle = {
  background: 'none',
  margin: 0,
  padding: 0,
  textAlign: 'left',
  cursor: 'pointer',
  appearance: 'none',
  borderWidth: 0,
  touchAction: 'manipulation',
  '::-moz-focus-inner': {
    borderWidth: 0,
    padding: 0
  }
};
var linkResetStyle = {
  textDecoration: 'none'
};
export var Click =
/*#__PURE__*/
React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      extend = _ref.extend,
      href = _ref.href,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["children", "extend", "href", "disabled", "onClick"]);

  var hasHref = typeof href === 'string';
  var as = hasHref ? 'a' : 'button';
  var rel = getLinkRel(props);
  return (
    /*#__PURE__*/
    React.createElement(Block, _extends({}, props, {
      disabled: as === 'button' && disabled,
      href: !disabled && hasHref ? href : undefined,
      onClick: !disabled && onClick ? onClick : undefined,
      ref: ref,
      as: as,
      rel: rel,
      type: as === 'button' ? props.type || 'button' : null,
      extend: [{
        boxSizing: 'border-box'
      }, as === 'button' ? buttonResetStyle : linkResetStyle, extend]
    }), children)
  );
});
Click.displayName = 'Click';
Click.propTypes = {
  /** An object containing valid CSS style declarations */
  extend: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.array]),

  /** Setting an href attribute will force the component to render with an `<a>` tag */
  href: PropTypes.string,

  /** If rendering a button (by not supplying an href), this let's you provide a type attribute for that button */
  type: PropTypes.string,

  /** A JSX node */
  children: PropTypes.node,

  /** Set the Click to disabled */
  disabled: PropTypes.bool,

  /** An action that is fired on click */
  onClick: PropTypes.func
};